import { NavLink } from 'react-router';
import { useAppStore } from '@app/store/useAppStore';
import styles from './IconRail.module.css';

const KEY_DEPENDENT = new Set(['/chords', '/scales', '/progressions']);

const ITEMS: { to: string; label: string; icon: string }[] = [
  { to: '/', label: 'Key', icon: '◐' },
  { to: '/chords', label: 'Chords', icon: '♫' },
  { to: '/scales', label: 'Scales', icon: '\u{1D11E}' },
  { to: '/progressions', label: 'Progressions', icon: '⇨' },
  { to: '/settings', label: 'Settings', icon: '⚙' },
];

export function IconRail() {
  const hasKey = Boolean(useAppStore((s) => s.selectedKeyId));
  return (
    <nav className={styles.rail} aria-label="Primary">
      {ITEMS.map((item) => {
        const disabled = KEY_DEPENDENT.has(item.to) && !hasKey;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              [styles.link, isActive && styles.active, disabled && styles.disabled]
                .filter(Boolean)
                .join(' ')
            }
            aria-label={item.label}
            aria-disabled={disabled || undefined}
            onClick={(e) => {
              if (disabled) e.preventDefault();
            }}
          >
            <span className={styles.icon} aria-hidden>
              {item.icon}
            </span>
            <span className={styles.label}>{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
